module.exports = __webpack_public_path__ + "img/amibo3.ea327e20.png";